import React from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import classNames from "classnames";

import { header } from "./Header.module.scss";

const HeaderContainer = ({ className, children, fluid, ...props }) => (
  <header className={classNames(header, className)} {...props}>
    <Container fluid={fluid}>
      {children}
    </Container>
  </header>
);

HeaderContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fluid: PropTypes.bool
};

HeaderContainer.defaultProps = {
  className: "",
  children: null,
  fluid: true
};

export default HeaderContainer;
